__webpack_require__.p = "https://design-editor.staging.gelato.tech/";